import styled from "styled-components/macro";

import { borderRadius, space, zIndex } from "shared/styles/constants";
import { Button } from "shared/components/Button";

export const MapModalContent = styled.div`
  height: 100%;
  width: 100%;

  border-radius: ${borderRadius.m};

  > div {
    border-radius: inherit;
  }
`;

export const CloseMapButton = styled(Button)`
  position: absolute;
  right: 0;
  top: 0;

  margin: ${space.s};

  z-index: ${zIndex.modal + 1};

  width: auto; // safari fix
  padding: ${space.xs};

  border-radius: 50%;
`;
